import { render, staticRenderFns } from "./ModalFileOrUrl.vue?vue&type=template&id=1e20a818&scoped=true&"
import script from "./ModalFileOrUrl.vue?vue&type=script&lang=js&"
export * from "./ModalFileOrUrl.vue?vue&type=script&lang=js&"
import style0 from "./ModalFileOrUrl.vue?vue&type=style&index=0&id=1e20a818&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e20a818",
  null
  
)

export default component.exports